import { Component, OnInit } from '@angular/core';
import {FormGroup, FormControl,Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import { ToastService } from 'src/app/core/services/misc/toast.service';

@Component({
  selector: 'app-ct-angiogram',
  templateUrl: './ct-angiogram.component.html',
  styleUrls: ['./ct-angiogram.component.scss']
})
export class CtAngiogramComponent implements OnInit {

  ct_angiogram_form = new FormGroup({
    name: new FormControl('', Validators.compose([ Validators.required,])),
    value1: new FormControl(''),
    value2: new FormControl(''),
    value3: new FormControl(''),
    date: new FormControl(''),
    remarks: new FormControl(''),
  });

  constructor(
    private matDialogRef: MatDialogRef<any>,
    private toast: ToastService,
    ) {}

  ngOnInit(): void {
  }

  save() {
    if(this.ct_angiogram_form.value.name){
      const object = this.ct_angiogram_form.value;
      object.is_default = false
      object.selected = true
      this.matDialogRef.close(object);
    }else{
      this.toast.showError('Please Enter Name');
    }

  }
}
